/* eslint-disable react-native/no-inline-styles */
import React, { forwardRef, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
// import cloneDeep from 'lodash/cloneDeep';
import { Col, Row, Button, Modal } from "react-bootstrap";
import { IoEyeOutline } from "react-icons/io5";
// import Divider from '@mui/material/Divider';


// import KeyInfoDetails from './KeyInfoDetails';

const PropertyInfo = forwardRef(({
    pdpData,
    pdpPropertyFees,
    emd,
    status,
    getbidcenterdata,
    isFcOnlineFlag,
}, ref) => {
    // const [showBuyer, setBuyerShow] = useState(false);
    // const [showEarnestToolTip, setEarnestToolTipShow] = useState(false);
    // const [earnestSelectedIndex, setEarnestSelectedIndex] = useState();
    // const [showTechnology, setTechnology] = useState(false);
    // const [showBuyerPay, setBuyerPay] = useState(false);
    const pdpInitData = useSelector(state => state.pdp?.pdpInitData);

    const {
        propertyId,
        detailedAttributes,
        commonAttributes,
        address,
    } = pdpData?.propertyDetails;

    const {
        airConditionCount,
        golfCourseCount,
        clubHouseCount,
        tennisCourtCount,
        backyardCount,
        fireplacesCount,
        basementCount,
        swimmingPoolCount,
        deckPatioCount,
        subdivision,
        parkingCount,
        squareFeet,
        hoaDues,
        hasAc,
        hoaFrequency,
        basementType,
        floorsNum,
        halfBathsNum,
        waterView,
        fullBathsNum,
        numberOfViews,
    } = detailedAttributes;


    // const propertyView =
    //   detailedAttributes?.numberOfViews === '2' ? 'View' : 'Views';

    const airCondition = hasAc === false ? 'No' : 'Yes';
    const pdpEnabledFeatures = pdpData?.propertySpecialDetails?.pdpEnabledFeatures;
    const webTransactionFee = pdpData?.propertySpecialDetails?.webTransactionFee;

    const shortSaleFlag = pdpData?.propertySpecialDetails?.shortSaleFlag;

    const buyerAgentCommissionPercent = pdpData?.propertySpecialDetails?.buyerAgentCommissionPercent;

    const buyerAgentCommissionAmount = pdpData?.propertySpecialDetails?.buyerAgentCommissionAmount;




    const { listingType } = pdpData.listingDetail;
    const { propCategory } = commonAttributes;
    const buyerAgentCommissionText =
        buyerAgentCommissionPercent > 1 && buyerAgentCommissionAmount !== 0
            ? 'Greater of ' +
            buyerAgentCommissionPercent +
            '% of sale price or $' +
            buyerAgentCommissionAmount + '.'
            : buyerAgentCommissionAmount !== 0
                ? '$' + buyerAgentCommissionAmount
                : buyerAgentCommissionPercent > 1
                    ? buyerAgentCommissionPercent
                    : 'Not Offered';
    const { isPrelistAsset, apnTaxId, isAllowedPreSale } = detailedAttributes;
    const hasAPN = apnTaxId !== '';
    const isPreviewProperty = isAllowedPreSale !== null;

    const beds = commonAttributes?.bedroomsNum;
    const showBid =
        isFcOnlineFlag === 'Y' ||
        (propCategory !== 'FORECLOSURE' &&
            isPrelistAsset !== 'PREVIEW' &&
            listingType !== 'TRNL');



    const hasAtLeastOne = item => item !== '' && parseInt(item, 10) > 0;
    const getBuyersPremimum = () => {
        if (pdpEnabledFeatures?.includes(pdpEnabledFeatures, 'SELLER')) {
            return pdpPropertyFees?.sellerPremiumText;
        } else if (
            pdpData?.revisedBuyerPremium !== undefined &&
            pdpData?.revisedBuyerPremiumPercentage
        ) {
            if (pdpData?.revisedBuyerPremium && pdpData?.revisedBuyerPremium <= 0) {
                return pdpPropertyFees?.buyerPremiumTxtAmt0;
            } else if (
                pdpData?.revisedBuyerPremiumPercentage &&
                pdpData?.revisedBuyerPremiumPercentage <= 0
            ) {
                return pdpPropertyFees?.buyerPremiumTxtPer0;
            } else {
                return pdpPropertyFees?.buyerPremiumDetails
                    .replace('###BP_PER###', pdpData.revisedBuyerPremiumPercentage)
                    .replace('###BP_AMOUNT###', pdpData.revisedBuyerPremium);
            }
        }
        return '';
    };

    const showBuyersPremimum = getBuyersPremimum() !== ''

    var showTechnologyFee =
        webTransactionFee?.replace('$', '').length === 0 ||
            webTransactionFee === '-' ||
            webTransactionFee === '$0'
            ? false
            : true;
    // const showTechnologyFee = trxFee ? false : true;

    const qtyWithLabel = (singular, plural, count) =>
        count + ' ' + (count > 1 ? plural : singular);




    const getHOAText = () => {
        if (hoaFrequency === '-') {
            return 'Yearly'
        } else {
            return hoaFrequency;
        }

    }

    const showEarnest =
        shortSaleFlag === 'N' &&
        propCategory !== 'FORECLOSURE' &&
        isPrelistAsset !== 'PREVIEW';
    return (


        <div ref={ref} className="propertyInfoBox mb30 tour-pdp-details">
            <div className="propertyInfoBoxHeading p0 d-flex justify-content-space-between">
                <h3 className='propertyInfoBoxHeadingTextInfo mobile-fs-pso' >
                    Property Details for {pdpInitData?.propertyDetails?.address?.streetNumber + " " + pdpInitData?.propertyDetails?.address?.streetName}
                </h3>
                <div className='propertyInfoBoxHeadingEyeText' >
                    <IoEyeOutline size="30px" style={{ color: '#118BF4' }} />
                    <div className='views-text-bold ml5 mobile-fs-pso'>{detailedAttributes?.numberOfViews ? detailedAttributes?.numberOfViews : 0}</div>
                    <div className='views-text ml5 mobile-fs-pso'>{parseInt(detailedAttributes?.numberOfViews) > 1 ? ' Views' : ' View'}</div>
                </div>
            </div>

            <div className="container p30">

                <Row xs={12} md={12} className="d-flex align-items-start ">


                    {/* <Col  md={12} > */}
                    {hasAtLeastOne(beds) && (
                        <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                            <div className="pt15">
                                <p className="pdpText tabfs">Beds:
                                </p>
                                <p className='pdpHeadingMedium tabfs'>{beds}</p>

                            </div>

                        </Col>
                    )}
                    {hasAtLeastOne(fullBathsNum) && (
                        <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                            <div className="pt15">
                                <p className="pdpText tabfs">Full Baths: </p>
                                <p className='pdpHeadingMedium tabfs'>{fullBathsNum}</p>
                            </div>
                        </Col>
                    )}



                    {hasAtLeastOne(halfBathsNum) && (
                        <Col xs={12} md={4} className="d-flex align-items-start">

                            <div className="pt15">
                                <p className="pdpText tabfs">Half Baths: </p>
                                <p className='pdpHeadingMedium tabfs'>{halfBathsNum}</p>
                            </div>
                        </Col>
                    )}

                    {hasAc &&

                        <Col xs={12} md={4} className="d-flex align-items-start">

                            <div className="pt15">
                                <p className="pdpText tabfs">Air Conditioning: </p>
                                <p className='pdpHeadingMedium tabfs'>{airCondition}</p>
                            </div>
                        </Col>

                    }





                    {/* </Row>



                <Row xs={12} md={12} className="d-flex align-items-start"> */}

                    {/* <Col  md={12} > */}
                    {
                        commonAttributes.lotSize !== 0 &&
                        commonAttributes.lotSize !== "0 Sq. Ft." &&
                        commonAttributes.lotSize !== null &&
                        <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                            <div className="pt15">
                                <p className="pdpText tabfs">Lot Size: </p>
                                <p className='pdpHeadingMedium tabfs'>
                                    {commonAttributes.lotSize}
                                    {' '}
                                    {(() => {
                                        let unit = (commonAttributes.lotSizeUnit !== null && commonAttributes.lotSizeUnit !== '') ? commonAttributes.lotSizeUnit : 'Sq. Ft.';
                                        // Capitalize the "a" in acre (e.g. "acre" -> "Acre")
                                        if (unit && unit.toLowerCase().startsWith('acre')) {
                                            unit = unit.charAt(0).toUpperCase() + unit.slice(1);
                                        }
                                        return unit;
                                    })()}
                                </p>
                            </div>
                        </Col>

                    }

                    {
                        detailedAttributes.squareFeet !== 0 &&
                        detailedAttributes.squareFeet !== "" &&
                        detailedAttributes.squareFeet !== null &&
                        detailedAttributes.squareFeet !== "-" &&
                        detailedAttributes.squareFeet !== "0 Sq. Ft." &&

                        <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                            <div className="pt15">
                                <p className="pdpText tabfs">Size: </p>
                                <p className='pdpHeadingMedium tabfs'>{detailedAttributes.squareFeet}</p>

                            </div>
                        </Col>
                    }



                    <Col xs={12} md={4} className="d-flex align-items-start">

                        <div className="pt15">
                            <p className="pdpText tabfs">Property ID: </p>
                            <p className='pdpHeadingMedium tabfs'>{propertyId}</p>
                        </div>
                    </Col>


                    {/* </Row>


                <Row xs={12} md={12} className="d-flex align-items-start"> */}

                    {/* <Col  md={12} > */}

                    {
                        commonAttributes.yearBuilt &&
                        commonAttributes.yearBuilt !== "" &&
                        commonAttributes.yearBuilt !== null &&
                        commonAttributes.yearBuilt !== 0 &&
                         <Col xs={12} md={4} className="d-flex align-items-start">

                        <div className="pt15">
                            <p className="pdpText tabfs">Year Built:</p>
                            <p className='pdpHeadingMedium tabfs'>{commonAttributes.yearBuilt}</p>
                        </div>
                    </Col>
                    }


                    {
                        address.county !== null &&
                        address.county !== 'null' &&
                        address.county !== '' &&
                        <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                            <div className="pt15">
                                <p className="pdpText tabfs">County: </p>
                                <p className='pdpHeadingMedium tabfs'>{address.county}</p>
                            </div>

                        </Col>
                    }


                    <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                        <div className="pt15">
                            <p className="pdpText tabfs">Property Type:</p>
                            <p className='pdpHeadingMedium tabfs'>{commonAttributes?.type === "RES" ? "Residential" : commonAttributes?.type}</p>
                        </div>

                    </Col>



                    {/* </Row>

                <Row xs={12} md={12} className="d-flex align-items-start"> */}

                    {/* <Col  md={12} > */}
                    {
                        commonAttributes.subType !== "" &&
                        commonAttributes.subType !== null &&
                        <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                            <div className="pt15">
                                <p className="pdpText tabfs">Sub Type: </p>
                                <p className='pdpHeadingMedium tabfs'>{commonAttributes.subType}</p>
                            </div>

                        </Col>
                    }




                    {detailedAttributes.subdivision.length > 0 &&
                        detailedAttributes.subdivision !== '-' &&
                        detailedAttributes.subdivision !== 'undefined' &&
                        <Col xs={12} md={4} className="d-flex align-items-start">

                            <div className="pt15">
                                <p className="pdpText tabfs">Sub Division:</p>
                                <p className='pdpHeadingMedium tabfs'>{subdivision}</p>
                            </div>
                        </Col>
                    }

                    {detailedAttributes.mlsNum.length > 0 &&
                        detailedAttributes.mlsNum !== '-' &&
                        detailedAttributes.mlsNum !== 'undefined' ? (


                        <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                            <div className="pt15">
                                <p className="pdpText tabfs">MLS ID: </p>
                                <p className='pdpHeadingMedium tabfs'>{detailedAttributes.mlsNum}</p>
                            </div>

                        </Col>
                    ) : (

                        <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                            <div className="pt15">
                                <p className="pdpText tabfs">MLS ID: </p>
                                <p className='pdpHeadingMedium tabfs'>NA</p>
                            </div>

                        </Col>
                    )}


                    {hoaDues.length > 0 &&
                        hoaDues !== '-' &&
                        hoaDues !== 'undefined' &&

                        <Col xs={12} md={4} className="pdpText d-flex align-items-start">
                            <div className="pt15">
                                <p className="pdpText tabfs">HOA Dues:</p>
                                <p className='pdpHeadingMedium tabfs'>{hoaDues + " " + getHOAText()}</p>
                            </div>

                        </Col>
                    }





                </Row>



            </div>

        </div>
    );
});

PropertyInfo.displayName = 'PropertyInfo';

export default PropertyInfo;

